export const transitions = {
  fast: '100ms ease-in-out',
  slow: '250ms ease-in-out',
};

export type ThemeTransitions = typeof transitions;
